module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/06_shape-md-00d731f27514acfea5fe1cd43b72edf6.png";